import { useTranslation } from 'react-i18next'

import { useLanguage } from '../../modules/i18n'
import EnglishContent from './BookingTermsLongDistance.en'
import FrenchContent from './BookingTermsLongDistance.fr'
import PageTitle from '../../components/layout/PageTitle/PageTitle'
import FullWidthPage from '../../components/layout/FullWidthPage'
import Container from '../../components/Container/Container'

const BookingTermsLongDistancePage: React.FC = () => {
  const { t } = useTranslation()
  const language = useLanguage()

  return (
    <FullWidthPage>
      <PageTitle>{ t('pages.bookingTermsLongDistance.title') }</PageTitle>
      <Container>
        <div className="prose mb-8 max-w-none font-body prose-headings:font-body2">
          { language === 'fr' ? <FrenchContent /> : <EnglishContent /> }
        </div>
      </Container>
    </FullWidthPage>
  )
}

export default BookingTermsLongDistancePage
